/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import { Text, Tooltip } from '@chakra-ui/react';
import useStore from '../../../store';

const Q_CANDIDATE = gql`
	query get($id: String!) {
		getAgentPartnerRequestCandidateById(id: $id) {
			id
			agent {
				id
				code
				name
				latinName
				nationality
			}
		}
	}
`;

export default function EventLoggingCandidatePartnerRequest({ id = null }) {
	const { currentLang: lang } = useStore((state) => state.currentLang);
	const [getCandidate, { data }] = useLazyQuery(Q_CANDIDATE);

	useEffect(() => {
		if (id) {
			const variables = { id };
			getCandidate({ variables });
		}
	}, [id]);

	return (
		<>
			{data?.getAgentPartnerRequestCandidateById && (
				<Tooltip
					label={
						data?.getAgentPartnerRequestCandidateById?.agent?.nationality !== 'KH'
							? data?.getAgentPartnerRequestCandidateById?.agent?.latinName
							: lang === 'kh'
							? data?.getAgentPartnerRequestCandidateById?.agent?.name
							: data?.getAgentPartnerRequestCandidateById?.agent?.latinName
					}
				>
					<Text cursor="pointer" fontSize="sm" fontWeight="semibold" color="gray.500">
						{data?.getAgentPartnerRequestCandidateById?.agent?.code}
					</Text>
				</Tooltip>
			)}
		</>
	);
}
